import { Link } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import animation from "../../../../Animation/media buying (1).json";

import { useGSAP } from "@gsap/react";
import { useTranslation } from "react-i18next";
import Lottie from "react-lottie";
import { Menu } from "../../../../Context/MenuOpen/MenuContext";

gsap.registerPlugin(ScrollTrigger);

const AboutMediaProduction = () => {
  const { t , i18n} = useTranslation()
  const contentRef = useRef(null);
  const lottieContainerRef = useRef(null);
  const menu = useContext(Menu);
  const isOpen = menu.isOpen;
  const [playLottie, setPlayLottie] = useState(false);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useGSAP(() => {
    gsap.from(contentRef.current, {
      scrollTrigger: {
        trigger: contentRef.current,
        start: "top 80%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 50,
      duration: 1,
      ease: "power3.out",
    });
    
      ScrollTrigger.create({
        trigger: lottieContainerRef.current,
        start: "top 80%",
        toggleActions: "play reverse play reverse",
        onEnter: () => setPlayLottie(true),
      });
  });

  return (
    <div className="StartProject px-[7vw] py-7 !flex-row">
      <div className="content" ref={contentRef}>
        <p className="py-3 fz-[1.1rem]">{t("Media production services")}</p>
        <h3>{t("Our philosophy")}</h3>
        <p>
          {t("Your story deserves more than just footage — it deserves a vision. At SunMed Agency, our media production team brings everything together under one team, all services, ensuring your narrative is cohesive and powerful.")}
          <br />
          {t("We don’t just film — we craft stories. From concept to delivery, our team handles video planning, shooting, directing, and post-production with seamless coordination. Forget patching together multiple vendors we’re your one-stop creative hub")}
        </p>
        <Link className="btn-hover">
          <span>{t("What’s include")}</span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
                <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0m-2 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0" />
                <path d="M12 19a7 7 0 1 0 0-14a7 7 0 0 0 0 14m0-2a5 5 0 1 0 0-10a5 5 0 0 0 0 10" />
                <path d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1S1 5.925 1 12s4.925 11 11 11m0-2a9 9 0 1 0 0-18a9 9 0 0 0 0 18" />
              </g>
            </svg>
          </span>
        </Link>
      </div>
      <div ref={lottieContainerRef} className="img">
      {playLottie || isOpen ? (
          <Lottie
            options={defaultOptions}
            className="custom-lottie"
            isClickToPauseDisabled={true}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default AboutMediaProduction;
